import { BodyRegular, FlexColSm, Headline3 } from 'components/Elements';
import styled from 'styled-components';

type AccordionPanelTitleProps = {
    title: string;
    description?: string;
};

export function AccordionPanelHeaderTitle({ title, description }: AccordionPanelTitleProps): JSX.Element {
    return (
        <PanelTitle>
            <Headline3>{title}</Headline3>
            {description && <DescriptionText>{description}</DescriptionText>}
        </PanelTitle>
    );
}

const PanelTitle = styled(FlexColSm)`
    overflow: hidden;
    text-align: left;
`;

const DescriptionText = styled(BodyRegular)`
    white-space: pre-wrap;
`;
